export default __webpack_public_path__ + "static/media/KOD0042-min.c94bb86c.webp";